import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { EmbeddedDataTable } from '@/components/data-table/embedded-data-table';
import { OrderDetail } from '@/lib/api/orders';
import { useEmbeddedPaymentsTableColumns } from './embedded-payments-table-columns';

interface OrderPaymentsCardProps {
  order: OrderDetail;
}

export function OrderPaymentsCard({ order }: OrderPaymentsCardProps) {
  const { t } = useTranslation('orders');
  const columns = useEmbeddedPaymentsTableColumns();

  if (!order.payments || order.payments.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{t('payments')}</CardTitle>
          <CardDescription>{t('noPayments')}</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  // Ensure payments have currency from order if not set and match PaymentRow type
  const paymentsWithCurrency = order.payments.map((payment) => ({
    id: payment.id,
    status: payment.status,
    amount: payment.amount,
    currency: (payment as any).currency || order.currency || 'USD',
    createdAt: payment.createdAt,
    paymentInstrument: payment.paymentInstrument || undefined,
    metadata: (payment as any).metadata || undefined,
    // On-chain crypto: the coin, the network and Test, which the metadata alone cannot say.
    cryptoOnchain: payment.cryptoOnchain ?? undefined,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('payments')}</CardTitle>
        <CardDescription>
          {order.payments.length} {order.payments.length !== 1 ? t('transactions') : t('transaction')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <EmbeddedDataTable
          columns={columns}
          data={paymentsWithCurrency as any}
          emptyMessage={t('noPayments')}
        />
      </CardContent>
    </Card>
  );
}
